if (!customElements.get('advanced-back-in-stock')) {
  class AdvancedProductUpsell extends HTMLElement {
    constructor () {
      super();
      this.observer = new MutationObserver(this.observerCallback.bind(this));
      this.observerConfig = { subtree: true, childList: true };
      this.storageKey = 'bis-subscribed-variants';
      this.currentVariant = this.dataset?.currentVariant ?? null;
      this.originalFetch = window.fetch.bind(window);
      this.catchURL = '/v2/back_in_stock/subscribe';
      this.subscribedVariant = null;
      if (this.currentVariant !== null) {
        this.currentVariant = this.currentVariant * 1;
      }
      const blockSettingsData = this.querySelector(`*[data-params]`)?.textContent;
      try {
        if (blockSettingsData) {
          this.params = JSON.parse(blockSettingsData);
        }
      } catch (e) {
        console.warn(e.message);
        this.params = {
          settings: {
            back_instock_confirmation_message: '',
            back_instock_subscribed_message: '',
            back_instock_color_scheme: '',
          },
          variants: [],
        };
      }
    }

    get container () {
      return this.querySelector('#ps__bis_container_root');
    }

    observerCallback (mutations) {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {

        }
      });
    }

    disconnectedCallback () {
      if (this.form) {
        document.addEventListener('variant:change', this.formChangeHandle.bind(this));
        this.form.removeEventListener('BISSubscribed', this.renderMessage.bind(this));
        this.destroyCatchRequest();
      }
    }

    get storage () {
      let _storage;
      try {
        _storage = localStorage.getItem(this.storageKey);
        if (!_storage) {
          throw new Error('bis storage not found');
        }
        _storage = JSON.parse(_storage);
      } catch (e) {
        console.warn(e);
        _storage = [];
      }
      return _storage;
    }

    set storage (value) {
      let _storage = this.storage;
      _storage.push(value);
      this.renewStorage(_storage);
    }

    renewStorage (_storage) {
      try {
        _storage = JSON.stringify(_storage);
        localStorage.setItem(this.storageKey, _storage);
      } catch (e) {
        console.warn(e);
      }
    }

    isAvailable () {
      let storage = this.storage;
      if (this.currentVariant && !this.params.variants.includes(this.currentVariant)) {
        storage = storage.filter((item) => item !== this.currentVariant);
        this.renewStorage(storage);
        return true;
      }
      return false;
    }

    formChangeHandle (e) {
      console.log(e);
      const variant = e?.detail?.variant?.id ?? null;
      if (variant) {
        this.currentVariant = variant;
        this.form.dispatchEvent(new CustomEvent('BISSubscribed'));
      }
    }

    getMessage () {
      let confirmedMessage = this.params.settings.back_instock_confirmation_message;
      let subscribedMessage = this.params.settings.back_instock_subscribed_message;
      if (!confirmedMessage) {
        confirmedMessage = subscribedMessage;
      }
      if (!subscribedMessage) {
        subscribedMessage = confirmedMessage;
      }
      return this.subscribedVariant ? confirmedMessage : subscribedMessage;
    }

    get messageContainer () {
      return this.form.querySelector('.back-in-stock-subscribed-message');
    }

    addMessage () {
      let element = this.messageContainer;
      if (!element) {
        element = document.createElement('div');
        element.classList.add('back-in-stock-subscribed-message');
        element.classList.add('gradient');
        if(this.params.settings.back_instock_color_scheme) {
          element.classList.add(`color-${this.params.settings.back_instock_color_scheme}`);
        }
        this.form.append(element);
      }
      element.innerHTML = this.getMessage();
    }

    removeMessage () {
      const element = this.messageContainer;
      if (element) {
        element.remove();
      }
    }

    renderMessage () {
      if (!this.isAvailable()) {
        if (this.storage.includes(this.currentVariant)) {
          this.addMessage();
          return;
        }
      }
      this.removeMessage();
    }

    catchRequest () {
      window.fetch = async (input, init) => {
        if (init && init.method === 'POST' && input.includes(this.catchURL)) {
          if (init.body) {
            let submittedVariant = null;
            if (typeof init.body === 'object') {
              submittedVariant = init.body?.variant_id ?? null;
            } else if (typeof init.body === 'string') {
              const initBody = JSON.parse(init.body);
              submittedVariant = initBody?.variant_id ?? null;
            }
            if (submittedVariant) {
              submittedVariant = submittedVariant * 1;
              this.subscribedVariant = submittedVariant;
              this.storage = submittedVariant;
              this.form.dispatchEvent(new CustomEvent('BISSubscribed'));
            }
          }
        }
        return this.originalFetch(input, init);
      };
    }

    destroyCatchRequest () {
      window.fetch = this.originalFetch;
    }

    connectedCallback () {
      requestAnimationFrame(() => {
        this.form = this.querySelector('form[action="/cart/add"]');
        if (this.form) {
          this.form.addEventListener('BISSubscribed', this.renderMessage.bind(this));
          this.catchRequest();
          this.form.dispatchEvent(new CustomEvent('BISSubscribed'));
          document.addEventListener('variant:change', this.formChangeHandle.bind(this));
        }
      });
    }
  }

  customElements.define('advanced-back-in-stock', AdvancedProductUpsell);
}

